import React from "react";

interface Props {
  isInvalid: boolean;
  message: React.ReactElement | string;
  placeholder?: boolean;
  className?: string;
}

const ValidationError = (props: Props) => {
  return (
    <>
{props.placeholder && (
      <div className={`requiredPlaceholder my-1 px-0 ${props.className}`}>
      {props.isInvalid && (
        <p className="validation-error px-0 my-0">
          {props.message}
        </p>
      )}
    </div> )}
    </>
  );
}
ValidationError.defaultProps = {
  isInvalid: true,
  message: '',
  placeholder: true
}

export default ValidationError;
